 import { FC } from "react";
import { headerPorps } from "../types";
import { PENDING_TABLE } from "src/constants/todos";
import GenericTableHeader from "../genericActionDashbaordHeader";

const PendingTableHeader: FC<headerPorps> = ({ queryParam, changeIdOrder }) => {
   return (
       <GenericTableHeader queryParam={queryParam} changeIdOrder={changeIdOrder} tableHeader={PENDING_TABLE} />  
    );
}

export default PendingTableHeader;